import { QueryClient } from "@tanstack/react-query";
import "bootstrap";

import renderProducts from "./components/renderProductsContainer";
import renderCategoryProducts from "./components/renderCategoryProductsContainer";
import renderProductDetails from "./components/renderProductsDetails";
import renderHeaderMenu from "./components/header/HeaderMenu";
import renderSearchResults from "./components/renderSearchResults";
import renderCartPage from "./components/renderCartPage";
import renderCheckoutPage from "./components/renderCheckoutPage";
import renderLoginPage from "./components/loginPage/renderLoginPage";

import store from "./store";

import "../styles/main.scss";

// hack for Firefox - to prevent cache on back navigation from browser
window.onunload = function () {};

// hack for Safari - to prevent cache on back navigation from browser
window.onpageshow = function (event) {
  if (event.persisted) {
    window.location.reload();
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

document.addEventListener("DOMContentLoaded", () => {
  renderProducts(store, queryClient);
  renderSearchResults(store, queryClient);
  renderCategoryProducts(store, queryClient);
  renderProductDetails(store, queryClient);
  renderCartPage(store, queryClient);
  renderCheckoutPage(store, queryClient);
  renderHeaderMenu(store, queryClient);
  renderLoginPage(store, queryClient);
});
